export const I18n = {
	'en': {
		all: 'All',
		pack: 'Package',
        total: 'Total'
	},
	'ru': {
		all: 'Все',
		pack: 'Пакет',
		total: 'Всего'
	},
	'sk': {
		all: 'Všetko',
		pack: 'Balíček',
		total: 'Sum'
	}
};



// WEBPACK FOOTER //
// ./src/I18n/components/singlePackage/index.js